// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dwZM","right":"styles_right__3qF8U"};